import service from '@/utils/server'

const modName = '/md/configFaceAccess/'

// 分页查询人脸门禁设备列表
export const pageInfo = data => {
  return service({
    url: modName + 'pageList',
    method: 'post',
    data
  })
}

// 人脸门禁设备启停（方法名不使用 switch 保留字）
export const faceAccessSwitch = data => {
  return service({
    url: modName + 'switch',
    method: 'post',
    data
  })
}



// WEBPACK FOOTER //
// ./src/page/md/runMaintain/faceAccess/api/index.js